/**
 * Created by razial on 27.05.2026.
 */

const Map2dBackgroundView = cc.Node.extend({
    ctor: function (map2d) {
        this._super();

        this.map2d = map2d;

        this.parts = {};

        map2d.on("changeBackground", this.refresh.bind(this), this);
        map2d.on("toggleDebugInfo", this.toggleDebugInfo.bind(this), this);

        if (cleverapps.config.debugMode) {
            cleverapps.flags.on("change:backgroundPencil", this.refresh.bind(this), this);
        }

        this.scheduleUpdateWithPriority(-1);
    },

    setVisibleRect: function (visibleRect) {
        this.visibleRect = visibleRect;
        this.visibleRectDirty = true;
    },

    update: function (dt) {
        this._super(dt);

        if (this.map2d.stopped) {
            return;
        }

        if (this.visibleRectDirty) {
            this.visibleRectDirty = false;
            this.updateVisibleParts();
        }

        if (cleverapps.config.editorMode && !this.debugGridNode) {
            this.createDebugGrid();
        }

        if (this.debugGridNode) {
            this.applyDebugZoomScale();
        }
    },

    applyDebugZoomScale: function () {
        const zoom = this.map2d.scroller.onDiscoverScrollView().zoom;
        if (zoom === this.appliedDebugZoom) {
            return;
        }
        if (zoom > 0.4 && this.appliedDebugZoom === 1) {
            return;
        }
        if (zoom > 0.4) {
            this.appliedDebugZoom = 1;
        } else if (zoom < 0.2) {
            this.appliedDebugZoom = 0.1;
        } else {
            this.appliedDebugZoom = zoom;
        }

        this.debugLayouts.forEach((layout) => layout.setScale(1 / this.appliedDebugZoom));
    },

    updateVisibleParts: function () {
        const rect = this.visibleRect;
        if (!rect) {
            return;
        }

        const bundle = this.map2d.getBackgroundBundle();
        if (!bundle) {
            return;
        }

        const scale = this.map2d.getBackgroundScale();
        const size = this.getPartSize();
        const zero = this.getPartPosition(0, 0);

        const stepX = size.width * scale.x;
        const stepY = size.height * scale.y;

        const offsetX = stepX / 4;
        const offsetY = stepY / 4;

        const minCol = Math.round((rect.x - offsetX - zero.x) / stepX) || 0;
        const maxCol = Math.round((rect.x + rect.width + offsetX - zero.x) / stepX) || 0;
        const minRow = Math.round((rect.y - offsetY - zero.y) / stepY) || 0;
        const maxRow = Math.round((rect.y + rect.height + offsetY - zero.y) / stepY) || 0;

        Object.values(this.parts).forEach((part) => {
            const row = part.row, col = part.col;
            if (row < minRow || row > maxRow || col < minCol || col > maxCol) {
                this.hidePart(row, col);
            }
        });

        for (let row = minRow; row <= maxRow; row++) {
            for (let col = minCol; col <= maxCol; col++) {
                this.showPart(row, col);
            }
        }
    },

    getPartPiece: function (row, col) {
        const n = Math.round(this.getOriginalPartSize().width / this.getPartSize().width) || 1;
        const shift = Math.floor(n / 2);

        const pieceCol = Math.floor((col + shift) / n);
        const pieceRow = Math.floor((row + shift) / n);
        const subX = col + shift - pieceCol * n;
        const subY = (n - 1) - (row + shift - pieceRow * n);

        return {
            row: pieceRow,
            col: pieceCol,
            subX: subX - (n - 1) / 2,
            subY: (n - 1) / 2 - subY,
            index: subY * n + subX
        };
    },

    getPartImage: function (row, col) {
        const bundle = this.map2d.getBackgroundBundle();
        const piece = this.getPartPiece(row, col);
        return bundle.urls[`bg_${piece.row}_${piece.col}_${piece.index}`];
    },

    getPartPosition: function (row, col) {
        const pos = this.map2d.getBackgroundPosition();
        const scale = this.map2d.getBackgroundScale();
        const size = this.getPartSize();
        const originalSize = this.getOriginalPartSize();
        const origin = this.getOrigin();

        const piece = this.getPartPiece(row, col);

        return cc.p(
            origin.x + originalSize.width * scale.x * piece.col + size.width * scale.x * piece.subX + pos.x,
            origin.y + originalSize.height * scale.y * piece.row + size.height * scale.y * piece.subY + pos.y
        );
    },

    getPartSize: function () {
        const bundle = this.map2d.getBackgroundBundle();
        const size = bundle && bundle.meta && bundle.meta.sizes && bundle.meta.sizes["bg_0_0_0"] || cc.size(0, 0);
        return cc.size(size.width * resolutionScale, size.height * resolutionScale);
    },

    getOriginalPartSize: function () {
        const bundle = this.map2d.getBackgroundBundle();
        const size = bundle && bundle.meta && bundle.meta.sizes && bundle.meta.sizes["bg_0_0"] || cc.size(0, 0);
        return cc.size(size.width * resolutionScale, size.height * resolutionScale);
    },

    getOriginalPartPath: function (row, col) {
        const bundle = this.map2d.getBackgroundBundle();
        const link = bundle && bundle.urls[`bg_${row}_${col}_0`];
        return link && link.originalPath();
    },

    getOrigin: function () {
        const vb = this.map2d.visibleBox;
        const totalWidth = this.width / (1 - vb.cutLeft - vb.cutRight);
        const totalHeight = this.height / (1 - vb.cutTop - vb.cutBottom);
        return {
            x: this.width / 2 + (vb.cutRight - vb.cutLeft) / 2 * totalWidth,
            y: this.height / 2 + (vb.cutTop - vb.cutBottom) / 2 * totalHeight
        };
    },

    showPart: function (row, col) {
        const key = `${row}_${col}`;

        if (this.parts[key]) {
            return;
        }

        const url = this.getPartImage(row, col);
        if (!url) {
            return;
        }

        const scale = this.map2d.getBackgroundScale();

        const part = this.parts[key] = {
            row,
            col,
            image: new cleverapps.UI.ThumbnailedSprite(url)
        };
        part.image.setAnchorPoint(0.5, 0.5);
        part.image.setScale(scale.x, scale.y);
        part.image.setPosition(this.getPartPosition(row, col));
        this.addChild(part.image);
    },

    hidePart: function (row, col) {
        const key = `${row}_${col}`;

        if (!this.parts[key]) {
            return;
        }

        const part = this.parts[key];
        delete this.parts[key];

        part.image.removeFromParent();
    },

    refresh: function () {
        Object.values(this.parts).forEach((part) => {
            this.hidePart(part.row, part.col);
        });

        this.visibleRectDirty = true;

        if (cleverapps.config.debugMode) {
            this.createDebugGrid();
        }
    },

    toggleDebugInfo: function () {
        this.debugInfoMode = !this.debugInfoMode;
        this.visibleRectDirty = true;

        if (cleverapps.config.debugMode) {
            this.createDebugGrid();
        }
    },

    createDebugGrid: function () {
        if (this.debugGridNode) {
            this.debugGridNode.removeFromParent();
            this.debugGridNode = undefined;
        }
        this.debugLayouts = [];
        this.appliedDebugZoom = undefined;

        const pos = this.map2d.getBackgroundPosition();
        const scale = this.map2d.getBackgroundScale();
        const origin = this.getOrigin();

        const partSize = this.getPartSize();
        const originalSize = this.getOriginalPartSize();
        const n = Math.round(originalSize.width / partSize.width) || 1;
        const shift = Math.floor(n / 2);

        const stepX = partSize.width * scale.x;
        const stepY = partSize.height * scale.y;
        const pieceWidth = originalSize.width * scale.x;
        const pieceHeight = originalSize.height * scale.y;

        const draw = this.debugGridNode = new cc.DrawNode();
        draw.setLocalZOrder(1000);

        if (this.debugInfoMode && cleverapps.config.editorMode) {
            this.parent.addChild(draw, 2);
        } else {
            this.addChild(draw);
        }

        // eslint-disable-next-line no-unused-vars
        const drawRect = (p1, p2, color, width) => {
            this.debugInfoMode && draw.drawRect(p1, p2, cc.color(0, 0, 0, 0), width || 2, color);
        };

        const bundle = this.map2d.getBackgroundBundle();

        const pieces = {};

        Object.keys(bundle.urls).forEach((key) => {
            const coords = key.match(/_(-?\d+)_(-?\d+)_(\d+)$/);
            if (!coords) {
                return;
            }

            const pieceRow = parseInt(coords[1], 10);
            const pieceCol = parseInt(coords[2], 10);
            const index = parseInt(coords[3], 10);

            pieces[`bg_${pieceRow}_${pieceCol}`] = { row: pieceRow, col: pieceCol };

            const col = pieceCol * n + index % n - shift;
            const row = pieceRow * n + (n - 1) - Math.floor(index / n) - shift;
            const point = this.getPartPosition(row, col);

            drawRect(
                cc.p(point.x - stepX / 2, point.y - stepY / 2),
                cc.p(point.x + stepX / 2, point.y + stepY / 2),
                cc.color(255, 255, 0, 255)
            );
        });

        Object.keys(pieces).forEach((id) => {
            const data = pieces[id];
            const x = origin.x + pieceWidth * data.col + pos.x;
            const y = origin.y + pieceHeight * data.row + pos.y;

            drawRect(
                cc.p(x - pieceWidth / 2, y - pieceHeight / 2),
                cc.p(x + pieceWidth / 2, y + pieceHeight / 2),
                cc.color(255, 0, 0, 255),
                this.debugInfoMode ? 15 : undefined
            );

            const originalPath = this.getOriginalPartPath(data.row, data.col);
            if (originalPath) {
                const pencil = !cleverapps.flags.get("backgroundPencil") && this.createPencil(originalPath);
                let info, number;

                if (this.debugInfoMode) {
                    info = cleverapps.UI.generateOnlyText(`ScaleX: ${scale.x},\n ScaleY: ${scale.y},\n width: ${pieceWidth},\n height: ${pieceHeight}`, cleverapps.styles.FONTS.MAP2DDEBUGFONT);
                    if (cleverapps.config.editorMode) {
                        number = cleverapps.UI.generateOnlyText(id, cleverapps.styles.FONTS.MAP2DGRIDFONT);
                    }
                }

                const layout = new cleverapps.Layout([pencil, info, number]);
                layout.setPosition(x, y);
                draw.addChild(layout);
                this.debugLayouts.push(layout);
            }
        });
    },

    createPencil: function (originalPath) {
        const pencil = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.small_button_green,
            content: new cc.Sprite(bundles.dev_buttons.frames.icon_edit),
            onClicked: () => {
                let repo = originalPath.substring(0, originalPath.indexOf("/"));
                let resPath = originalPath.substring(repo.length);

                if (repo === "res") {
                    repo = cleverapps.config.name;
                    resPath = `/${originalPath}`;
                }

                const link = `https://github.com/Clever-Apps-Pte-Ltd/${repo}/tree/master${resPath}`;
                console.log(link);
                connector.platform.openUrl(link);
            },
            hint: "Open link to git"
        });
        pencil._setGlobalZOrder(true);
        return pencil;
    }
});

cleverapps.styles.DECORATORS.MAP2DDEBUGSTROKE = {
    color: cleverapps.styles.COLORS.WHITE,
    size: 4
};

cleverapps.styles.DECORATORS.MAP2DGRIDSTROKE = {
    color: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE_COLOR,
    size: 4
};

cleverapps.styles.FONTS.MAP2DGRIDFONT = {
    type: {
        name: "Arial"
    },
    size: 45,
    color: cleverapps.styles.COLORS.WHITE,
    stroke: cleverapps.styles.DECORATORS.MAP2DGRIDSTROKE,
    shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
};

cleverapps.styles.FONTS.MAP2DDEBUGFONT = {
    type: {
        name: "Arial"
    },
    size: 30,
    color: cleverapps.styles.COLORS.BLACK,
    stroke: cleverapps.styles.DECORATORS.MAP2DDEBUGSTROKE,
    shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
};